<template lang="pug">
  b-card.border-0.customerCard.tempInput(
    bg-variant="light"
  )
    .text-right.mb-2(
      v-if="deleteMode"
    )
      i.fas.fa-times-circle.fa-lg(
        @click="deleteTempHandler(originalData.id, originalData.type)"
      )
    label.w-100.mb-0(
      :for="`checkbox-group-${index}`"
    )
      .row.mb-5
        .col-2.d-flex.align-items-center.justify-content-center(
          v-show="selectMode"
        )
          b-form-checkbox(
            :id="`checkbox-group-${index}`",
            name="selectTemps",
            :checked="isChecked"
            v-show="selectMode",
            @input="selectTempHandler(originalData.id, originalData.type)",
            :class="{ 'hidden-check': isChecked }"
          )
            label.check-label(
              v-if="isChecked"
            ) {{ order + 1 }}
        .position-relative(
          :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
        )
          img.img-fluid.w-100.h-100.rounded(:src="originalData.push_format.image")
      small.font-size-sm 建立者：{{ originalData.creator }}

</template>

<script>
const _ = require('lodash');

export default {
  name: 'image-map-input',
  props: {
    index: [String, Object, Number],
    // 父層資訊
    originalData: {
      type: Object,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    selectTemps: {
      type: Array
    },
    deleteMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectTempHandler(id, template) {
      const vm = this;
      vm.$emit('selectTempHandler', {
        id,
        template
      });
    },
    deleteTempHandler(id, template) {
      const vm = this;
      vm.$emit('deleteTempHandler', {
        id,
        template
      });
    }
  },
  computed: {
    isChecked() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      if (key) {
        return true;
      }
        return false;
    },
    order() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      return parseInt(key);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
